import { Drawer, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from "react";
import { FaBars, FaBoxes, FaBuilding, FaRegEnvelope, FaUsers } from "react-icons/fa";
import Logo from '../../assets/logo/logoHeader.svg';
import BlueButton from '../../components/buttons/blueButton';
import IconButton from '../../components/buttons/iconButton';
import '../header/header.css';


export default function Header(props) {

    const [active, setActive] = useState(false)

    function rolarParaOElemento(id) {
        setTimeout(() => {
            const element = window.document.getElementById(id)
            element.scrollIntoView()
        }, 10)
        setActive(false)
    }

    return (
        <header id="header" className="container-fluid d-flex justify-content-center">
            <Drawer open={active} anchor="left" onClose={() => setActive(false)}>
                <List style={{ width: '250px', marginTop:'60px' }} >
                    <ListItem button onClick={() => rolarParaOElemento('section1-role')} >
                        <ListItemIcon><FaBuilding style={{ color: "#26528C" }} /></ListItemIcon>
                        <ListItemText primary="Quem Somos" />
                    </ListItem>
                    <ListItem button onClick={() => rolarParaOElemento('section2-role')}>
                        <ListItemIcon><FaBoxes style={{ color: "#26528C" }} /></ListItemIcon>
                        <ListItemText primary="Soluções" />
                    </ListItem>
                    <ListItem button onClick={() => rolarParaOElemento('depoimentos-role')}>
                        <ListItemIcon><FaUsers style={{ color: "#26528C" }} /></ListItemIcon>
                        <ListItemText primary="Depoimentos" />
                    </ListItem>
                    <ListItem button onClick={() => rolarParaOElemento('section5-role')}>
                        <ListItemIcon><FaUsers style={{ color: "#26528C" }} /></ListItemIcon>
                        <ListItemText primary="Clientes" />
                    </ListItem>
                </List>
            </Drawer>

            <div className="container d-flex justify-content-center align-items-center p-0">
                <div className="row w-100">
                    <div className="col-3 d-md-none d-flex align-items-center justify-content-center iconButton">
                        <IconButton onClick={() => setActive(true)} bg="white" color="#26528C"><FaBars /></IconButton>
                    </div>

                    <div className="col-6 col-md-4 d-flex align-items-center justify-content-md-start  justify-content-center">
                        <img src={Logo} className="logo" alt="Logotipo da Oxfield" />
                    </div>

                    <div className="linksHeader col-md-8 d-none d-md-flex align-items-center justify-content-end">
                        <a href="#section1-role" className="mr-4">Quem Somos</a>
                        <a href="#section2-role" className="mr-4">Soluções</a>
                        <a href="#cases-role" className="mr-4">Cases</a>
                        <a href="#section5-role" className="mr-5">Clientes</a>
                        <BlueButton onClick={() => props.handleClickOpen()}>Fale com um especialista</BlueButton>
                    </div>


                    <div className="col-3 d-md-none d-flex align-items-center justify-content-center iconButton">
                        <IconButton onClick={() => props.handleClickOpen()} bg="white" color="#26528C"><FaRegEnvelope /></IconButton>
                    </div>


                </div>

            </div>


        </header>
    )
}